import { Toaster as Sonner } from 'sonner';

/** Avisos efêmeros (salvo, importado, erro). Ação opcional ("Ver lote"). */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            'rounded-cartao! border! border-borda! bg-superficie-elevada! text-texto! shadow-alta! font-sans!',
          description: 'text-texto-suave!',
          actionButton: 'bg-marca! text-marca-texto!',
        },
      }}
    />
  );
}
